import type { RunDescriptor } from '../contracts/game'
import { createDailyChallenge } from './DailyChallenge'

export type RunMode = 'endless' | 'daily' | 'apex'
export const APEX_SEED = 3_745_529_059

export function createRunDescriptor(
  mode: RunMode,
  tuningVersion: string,
  randomSeed: number,
  now = new Date(),
): RunDescriptor {
  if (mode === 'daily') {
    const challenge = createDailyChallenge(now)
    return {
      seed: challenge.seed,
      mode,
      tuningVersion,
      contentVersion: '2',
      replayVersion: 2,
      challengeId: challenge.id,
    }
  }
  return {
    seed: mode === 'apex' ? APEX_SEED : randomSeed >>> 0,
    mode,
    tuningVersion,
    contentVersion: '2',
    replayVersion: 2,
  }
}
